export const convertStringToNumber = (value: string): number => {
  return +value
}

export const compare = (num1: number, num2: number): number => {
  if (num1 > num2) {
    return 1
  } else if (num1 < num2) {
    return -1
  } else {
    return 0
  }
}

export const priorityCompare = (num1: number, num2: number): number => {
  if (num1 && !num2) {
    return -1
  } else if (!num1 && num2) {
    return 1
  } else if (!num1 && !num2) {
    return 0
  } else {
    return compare(num1, num2)
  }
}
